import {provideRouter, withInMemoryScrolling} from '@angular/router';
import {provideAnimations} from "@angular/platform-browser/animations";
import {ApplicationConfig, provideZoneChangeDetection} from '@angular/core';
import {provideHttpClient, withFetch, withInterceptors} from "@angular/common/http";
import {provideClientHydration, withHttpTransferCacheOptions} from '@angular/platform-browser';

import {provideToastr} from "ngx-toastr";

import {routes} from './app.routes';
import {accessTokenInterceptor, notFoundInterceptor, errorHandlerInterceptor} from "@numizmat/interceptors";

export const appConfig: ApplicationConfig = {
  providers: [
    provideToastr({
      progressBar: true
    }),
    provideAnimations(),
    provideRouter(routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled'
      })),
    provideZoneChangeDetection({eventCoalescing: true}),
    provideHttpClient(
      withFetch(),
      withInterceptors([
        notFoundInterceptor,
        accessTokenInterceptor,
        errorHandlerInterceptor
      ])),
    provideClientHydration(withHttpTransferCacheOptions({
      includePostRequests: true,
      includeRequestsWithAuthHeaders: true
    }))
  ]
};
